<template>
  <v-layout wrap>
    <v-flex xs12 sm10 offset-sm-1>
      <v-card>
        <v-card-title class="display-1">
          <router-link :to="{ name: 'home' }">
            <v-btn icon large>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
          {{ categ.title }}
        </v-card-title>
        <v-carousel
          cycle
          height="400"
          hide-delimiter-background
          show-arrows-on-hover
        >
          <v-carousel-item v-for="(image, i) in categ.images" :key="i">
            <v-img
              :src="
                require(`@/assets/categories/${categ.pageName}/${image.ref}`)
              "
              height="100%"
            />
          </v-carousel-item>
        </v-carousel>

        <v-card-text align="center" class="title font-weight-regular">
          {{ categ.description }}
        </v-card-text>
        <v-card-text align="center" v-if="categ.activities.length > 0">
          <v-list disabled>
            <div class="my-1 title">
              <v-icon large>build</v-icon>
              Activités
            </div>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item
                v-for="(item, i) in categ.activities"
                :key="i"
                class="no-min-height"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title
                    v-text="item.description"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-text align="center" v-if="categ.vehicles.length > 0">
          <v-list disabled>
            <div class="my-1 title">
              <v-icon large>local_shipping</v-icon>
              Parcs
            </div>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item
                v-for="(item, i) in categ.vehicles"
                :key="i"
                class="no-min-height"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title
                    v-text="item.description"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-text align="center" v-if="categ.references.length > 0">
          <v-list disabled>
            <div class="my-1 title">
              <v-icon large>chat</v-icon>
              Références
            </div>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item
                v-for="(item, i) in categ.references"
                :key="i"
                class="no-min-height"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title
                    v-text="item.description"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Category",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["getCategoriesByPageName"]),
    categ() {
      var myCateg = this.getCategoriesByPageName(this.$route.params.category);
      document.title = "Vtsv - " + myCateg.title;
      return myCateg;
    },
  },
};
</script>

<style scoped>
.no-min-height {
  min-height: 0px;
}

.v-list-item__title {
  white-space: inherit;
}
</style>
